// Copy shown in the consent/verification modal. Any key may be overridden per
// document (Document Settings -> Consent Modal) to support translations.
export const defaultConsentTranslations = {
  consent_title: 'Consent Required',
  verification_title: 'Verification Required',
  email_placeholder: 'Signer email',
  consent_text:
    'I agree that the signature and initials will be the electronic ' +
    'representation of my signature and initials for all purposes when I ' +
    '(or my agent) use them on documents, including legally binding contracts.',
  continue_button: 'Continue',
  email_error: 'Please enter an email address.',
  consent_error: 'Please agree to the terms.',
  auth_error: 'Failed to authenticate.'
};

export type ConsentTranslations = typeof defaultConsentTranslations;

export const resolveConsentTranslations = (
  overrides?: Partial<ConsentTranslations>
): ConsentTranslations => ({
  ...defaultConsentTranslations,
  ...(overrides ?? {})
});
